<template>

  <v-tooltip bottom>
    <template v-slot:activator="{ on }">
      <span v-on="on">
        <v-text-field
          :label="label"
          :style="adjustStyle"
          solo
          flat
          placeholder="フリーワード"
          v-bind="computedProps"
          v-on="computedListeners">
          <template v-slot:append>
            <v-icon color="#83bde5" style="padding-top:3px !important">mdi-magnify</v-icon>
          </template>
        </v-text-field>
      </span>
    </template>
    <span>入力した値で一覧を絞り込む事ができます。</span>
  </v-tooltip>

</template>
<script>
import { VTextField } from 'vuetify/lib'

/**
 * @file DDv2用絞り込みテキスト
 * @namespace components
 */

/**
 * @vue-prop {Number} [length=999] - 入力可能桁数
 * @see https://vuetifyjs.com/ja/api/v-text-field/
 * @example
  <dd-narrow-down-text-box
    v-model="searchText"/>
 */
export default {
  name: 'DdNarrowDownTextBox',
  extends: VTextField,
  props: {
    /**
     * 入力可能桁数
     */
    length: Number,
    /**
     * スタイル指定
     */
    adjustStyle: {
      type: String,
      default: 'padding-top:16px'
    },
    label: {
      type: String,
      default: '絞り込み'
    }
  },
  data: () => ({
  }),
  created () {
  },
  mounted () {
  },
  computed: {
    computedProps () {
      return {
        ...this.$props,
        maxlength: this.length,
        type: 'text',
        hideDetails: true,
        dense: true
      }
    },
    computedListeners () {
      return {
        ...this.$listeners,
        focus: e => this.onFocus(e)
      }
    }
  },
  methods: {
    onFocus: function (e) {
      const elem = this.$el.querySelector('input')
      if (elem) { elem.select() }
      this.$emit('focus', e)
    }
  }
}
</script>
<style scoped>
</style>
